import React from 'react'
import ModernBadge from 'components/ModernBadge'

export default function CompanyBadgeStatus({ status, showIcon = true }) {
  const statusConfig = {
    false: {
      variant: 'success',
      text: 'Activo',
      icon: 'check circle'
    },
    true: {
      variant: 'danger',
      text: 'Inactivo',
      icon: 'times circle'
    }
  }

  const config = statusConfig[status] || {
    variant: 'grey',
    text: status,
    icon: 'question'
  }

  return (
    <ModernBadge
      variant={config.variant}
      icon={showIcon ? config.icon : null}
    >
      {config.text}
    </ModernBadge>
  )
}

